<template>
  <div class="container">
    <div class="title">
      <div class="title1">
        <img src="../assets/img/logo.png" />
        <div>刘湾零工市场</div>
      </div>
      <div class="title2">
        <img src="../assets/img/head.png" alt="">
        <div>用户</div>
      </div>
    </div>
    <div class="content">
      <div @click="goLogin">返回</div>
      <div class="formContent">
        <div>找回密码</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-form-item label="手机" prop="userPhone">
            <el-input
              v-model="ruleForm.userPhone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="userPassword">
            <el-input
              show-password
              type="password"
              v-model="ruleForm.userPassword"
              autocomplete="off"
              placeholder="请输入密码"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              show-password
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
              placeholder="请再次输入密码"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="验证码" prop="smsCode" class="smsCodeStyle">
            <el-input
              v-model="ruleForm.smsCode"
              placeholder="请输入验证码"
            >
            </el-input>
            <div class="login-yan" @click="getPhoneCode">{{ codeButtonText }}</div>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm">确定</el-button>
            <el-button @click="goLogin">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        userPhone: "",
        userPassword: "",
        checkPass: "",
        smsCode: "",
      },
      codeButtonText: "发送验证码",
      rules: {
        userPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "填写正确的手机号", trigger: "blur" },

        ],
        userPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 8, max: 16, message: "长度在 8 到 16 个字符", trigger: "blur" },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,16}$/, message: "必须包含大写字母，小写字母，数字及特殊字符", trigger: "blur" },
        ],
        checkPass: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { min: 8, max: 16, message: "长度在 8 到 16 个字符", trigger: "blur" },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,16}$/, message: "必须包含大写字母，小写字母，数字及特殊字符", trigger: "blur" },
        ],
        smsCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
          { pattern: /^\d{6}$/, message: "填写正确的验证码", trigger: "blur" },
        ],
      },
      countdownTime: 60,
    };
  },
  mounted() {},
  methods: {
    goLogin() {
      this.$router.push("/login");
    },
    getPhoneCode() {
      if (this.codeButtonText == "重新发送" ||this.codeButtonText == "发送验证码") {
        this.$post("/api/common/sendSmsCode", {
          phone: this.ruleForm.userPhone,
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "验证码已发送，请注意查收！",
              type: "success",
            });
            let count = 60; // 设置倒计时时间（单位：秒）

            this.codeButtonText = `${count}s`; // 更新按钮显示的文本

            const timer = setInterval(() => {
              count--;

              if (count <= 0) {
                clearInterval(timer); // 清除计时器
                this.codeButtonText='重新发送'; // 复原按钮状态
              } else {
                this.codeButtonText = `${count}s`; // 更新按钮显示的文本
              }
            }, 1000);
          }
        });
      }
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.ruleForm.userPassword != this.ruleForm.checkPass) {
            this.$message({
              message: "两次密码输入不一致！",
              type: "error",
            });
            return;
          }
          if(!this.ruleForm.smsCode){
            this.$message({
              message: "请输入短信验证码",
              type: "error",
            });
            return;
          }
          this.$post("/api/company/companyUser/resetPassword", {
            ...this.ruleForm,
          }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "重置密码成功，请重新登录！",
                type: "success",
              });
              this.goLogin()
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-image: url("../assets/img/findPass.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .title {
    height: 30px;
    padding: 20px;
    background: #0051aa;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title1 {
      display: flex;
      align-items: center;
    }
    .title1>img {
      width: 34px;
      height: 34px;
    }
    .title1>div {
      //width: 87px;
      height: 33px;
      margin-left: 10px;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 24px;
      color: #ffffff;
      line-height: 33px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .title2 {
      display: flex;
      align-items: center;
    }
    .title2 >img {
      width: 30px;
      height: 30px;
      // background: #ffffff;
      border-radius: 50%;
      // font-weight: 500;
      // font-size: 14px;
      // color: #262626;
      // line-height: 30px;
      // text-align: center;
    }
    .title2 > div {
      height: 33px;
      margin-left: 10px;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      line-height: 33px;
      text-align: left;
    }
  }
  .content {
    padding: 20px;
    .formContent {
      width: 980px;
     // height: 783px;
     padding-bottom: 100px;
      padding-top: 30px;
      background: #ffffff;
      box-shadow: 0px 13px 26px 1px rgba(0, 0, 0, 0.05);
      border-radius: 12px;
      margin: 50px auto;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      .el-form {
        width: 500px;
        .smsCodeStyle {
          ::v-deep .el-form-item__content {
            display: flex;
            align-items: center;
          }
        }
        .login-yan {
          width: 150px;
          height: 44px;
          flex-shrink: 0;
          margin-left: 12px;
          background: #0051aa;
          border-radius: 2px 2px 2px 2px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #ffffff;
          line-height: 44px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
        }
      }
    }
    .formContent > div:nth-of-type(1) {
      width: 100%;
      height: 37px;
      margin-bottom: 30px;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 26px;
      color: #0051aa;
      line-height: 37px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }
  .content > div:nth-of-type(1) {
    width: 75px;
    height: 32px;
    background: #0051aa;
    border-radius: 2px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    cursor: pointer;
  }
}
</style>